import { supabase } from './supabase';

export async function invoke(name, body = {}) {
  if (!supabase) throw new Error('Supabase is not configured.');
  const { data, error } = await supabase.functions.invoke(name, { body });
  if (error) throw error;
  if (data?.error) throw new Error(data.error);
  return data;
}

export async function quoteCart(items, address, couponCode = '') {
  return invoke('commerce-quote', { items: items.map(i => ({ product_id: i.id, quantity: i.quantity })), address, coupon_code: couponCode || null });
}

export async function createPayment(items, address, couponCode = '') {
  return invoke('create-payu-payment', { items: items.map(i => ({ product_id: i.id, quantity: i.quantity })), shipping_address: address, coupon_code: couponCode || null });
}

export async function requestReturn(payload) { return invoke('request-return', payload); }
export async function requestReplacement(payload) { return invoke('request-replacement', payload); }
export async function requestRefund(payload) { return invoke('request-refund', payload); }
export async function sendEmail(payload) { return invoke('send-email', payload); }
export async function generateOtp(ticketId) { return invoke('generate-service-otp', { ticketId }); }
export async function verifyOtp(ticketId, otp) { return invoke('verify-service-otp', { ticketId, otp }); }
